// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import EscPosEncoder from "esc-pos-encoder";
// import {
//   Container,
//   Row,
//   Card,
//   Button,
//   Input,
//   Table,
//   CardHeader,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   Form,
//   FormGroup,
//   Col,
//   CardBody,
//   CardFooter,
// } from "reactstrap";
// import Header from "components/Headers/Header";
// import { useSessionStore } from "../../stores/sessionStore";
// import { useSettingStore } from "../../stores/settingStore";
// import { api } from "../../config/middleware";
// import { useTablePaging, PAGE_SIZE_OPTIONS } from "../../stores/pagingStore";
// import {
//   API_GETBILL,
//   API_GETBILLDETAIL,
//   API_GETSETTING,
// } from "../../config/api";

// const TABLE_KEY = "bills";

// const OrderOrgs = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const role = useSessionStore((s) => s.profile?.role);
//   const tnId = useSessionStore((s) => s.profile?.tnId);
//   const orgId = useSessionStore((s) => s.profile?.orgId);
//   const brId = useSessionStore((s) => s.profile?.brId);

//   const setBillMode = useSettingStore((s) => s.setBillMode);

//   useEffect(() => {
//     const fetchSetting = async () => {
//       const res = await api.get(API_GETSETTING, {
//         params: { TNID: tnId, ORGID: orgId, BRID: brId },
//       });

//       if (res.data?.statustext === "SUCCESS") {
//         setBillMode(res.data.data.billMode);
//       }
//     };

//     if (tnId != null && orgId != null && brId != null) {
//       fetchSetting();
//     }
//   }, [tnId, orgId, brId, setBillMode]);

//   const { page, pageSize, setPage, setPageSize } = useTablePaging(TABLE_KEY);

//   // ✅ responsive: จอเล็กใช้ table เดิม
//   const [isSmall, setIsSmall] = useState(window.innerWidth < 768);
//   useEffect(() => {
//     const onResize = () => setIsSmall(window.innerWidth < 768);
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   // ===== data/paging state =====
//   const [total, setTotal] = useState(0);
//   const [rowsPage, setRowsPage] = useState([]); // server-paged: แถวของหน้าปัจจุบัน
//   const [allRows, setAllRows] = useState([]); // client-paged: ดึงทั้งหมด
//   const [clientPaged, setClientPaged] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   // search
//   const [keyword, setKeyword] = useState("");
//   const serverModeRef = useRef(false); // เดิมเป็น server-paged ไหม
//   const reqIdRef = useRef(0);

//   // modal & form (เพิ่ม/แก้ไข)
//   const [isOpen, setIsOpen] = useState(false);
//   const [mode, setMode] = useState("add"); // add | edit
//   const [editingId, setEditingId] = useState(null);
//   const [form, setForm] = useState({
//     code: "",
//     name: "",
//     price: 0,
//     customerType: "55",
//   });
//   const customerTypeOptions = [
//     { value: "55", label: "บุคคลธรรมดา" },
//     { value: "56", label: "นิติบุคคล" },
//   ];
//   const [submitting, setSubmitting] = useState(false);

//   const toggle = () => setIsOpen((v) => !v);

//   const onChange = (e) => {
//     const { name, value, type } = e.target;
//     setForm((s) => ({
//       ...s,
//       [name]: type === "number" ? Number(value) : value,
//     }));
//   };

//   // ===== helpers =====
//   const getId = (it, i) =>
//     it.pdId ?? it.ID ?? `${it.pdCode ?? it.code ?? "row"}-${i}`;

//   const dedupeBy = (arr, idFn) => {
//     const m = new Map();
//     arr.forEach((x, i) => m.set(idFn(x, i), x));
//     return [...m.values()];
//   };

//   const pickTotal = (d) =>
//     Number(
//       d?.total ?? d?.count ?? d?.pagination?.total ?? d?.meta?.total ?? NaN,
//     );

//   const norm = (s) => (s || "").toString().toLowerCase().trim();

//   // ===== base rows + filter =====
//   const baseRows = clientPaged ? allRows : rowsPage;
//   const filteredRows = useMemo(() => {
//     const k = norm(keyword);
//     if (!k) return baseRows;
//     return baseRows.filter(
//       (r) =>
//         norm(r.bNumber ?? "").includes(k) ||
//         norm(r.cmCode ?? "").includes(k) ||
//         norm(r.cmName ?? "").includes(k) ||
//         norm(r.svName ?? "").includes(k),
//     );
//   }, [baseRows, keyword]);

//   const filteredTotal = filteredRows.length;
//   const filteredPageCount = Math.max(1, Math.ceil(filteredTotal / pageSize));

//   const displayRows = useMemo(() => {
//     const start = (page - 1) * pageSize;
//     return filteredRows.slice(start, start + pageSize);
//   }, [filteredRows, page, pageSize]);

//   const pages = useMemo(
//     () => Array.from({ length: filteredPageCount }, (_, i) => i + 1),
//     [filteredPageCount],
//   );

//   // ===== โหลดหน้าแรก =====
//   const fetchFirstPage = async () => {
//     if (!orgId) return;
//     const myReq = ++reqIdRef.current;
//     setIsLoading(true);
//     setClientPaged(false);
//     serverModeRef.current = false;
//     setRowsPage([]);
//     setAllRows([]);
//     setTotal(0);
//     setPage(TABLE_KEY, 1);

//     try {
//       const res = await api.get(API_GETBILL, {
//         params: { ORGID: orgId, BRID: brId },
//       });
//       if (myReq !== reqIdRef.current) return;

//       const raw = Array.isArray(res.data?.data) ? res.data.data : [];
//       const dedup = dedupeBy(raw, getId);
//       const totalFromApi = pickTotal(res.data);
//       const apiLooksPaged =
//         Number.isFinite(totalFromApi) && dedup.length <= pageSize;

//       if (apiLooksPaged) {
//         // server-paged
//         setClientPaged(false);
//         serverModeRef.current = true;
//         setRowsPage(dedup);
//         setTotal(totalFromApi);
//       } else {
//         // client-paged
//         serverModeRef.current = false;
//         setClientPaged(true);
//         const all = dedupeBy(raw, getId);
//         setAllRows(all);
//         setTotal(all.length);
//       }
//     } catch (e) {
//       console.error("fetchFirstPage error:", e);
//     } finally {
//       if (myReq === reqIdRef.current) setIsLoading(false);
//     }
//   };

//   // ===== โหลดหน้า N (server-paged เท่านั้น) =====
//   const fetchServerPage = async (nextPage) => {
//     const myReq = ++reqIdRef.current;
//     setIsLoading(true);
//     try {
//       const res = await api.get(API_GETBILL, {
//         params: { ORGID: orgId, BRID: brId },
//       });
//       if (myReq !== reqIdRef.current) return;
//       const raw = Array.isArray(res.data?.data) ? res.data.data : [];
//       const dedup = dedupeBy(raw, getId);
//       setRowsPage(dedup);
//     } catch (e) {
//       console.error("fetchServerPage error:", e);
//     } finally {
//       if (myReq === reqIdRef.current) setIsLoading(false);
//     }
//   };

//   // ===== ดึงทั้งหมดเพื่อค้นหาในโหมด server =====
//   const fetchAllForSearch = async () => {
//     if (!orgId) return;
//     const myReq = ++reqIdRef.current;
//     setIsLoading(true);
//     try {
//       const first = await api.get(API_GETBILL, {
//         params: { ORGID: orgId, BRID: brId },
//       });
//       if (myReq !== reqIdRef.current) return;

//       const firstRows = Array.isArray(first.data?.data) ? first.data.data : [];
//       const totalAll = pickTotal(first.data) || firstRows.length;
//       const pagesAll = Math.max(1, Math.ceil(totalAll / pageSize));
//       let all = dedupeBy(firstRows, getId);

//       for (let p = 2; p <= pagesAll; p++) {
//         const r = await api.get(API_GETBILL, {
//           params: { ORGID: orgId, BRID: brId },
//         });
//         if (myReq !== reqIdRef.current) return;
//         const part = Array.isArray(r.data?.data) ? r.data.data : [];
//         all = dedupeBy([...all, ...part], getId);
//       }

//       setClientPaged(true);
//       serverModeRef.current = true;
//       setAllRows(all);
//       setTotal(all.length);
//       setPage(TABLE_KEY, 1);
//     } catch (e) {
//       console.error("fetchAllForSearch error:", e);
//     } finally {
//       if (myReq === reqIdRef.current) setIsLoading(false);
//     }
//   };

//   // ===== lifecycle =====
//   useEffect(() => {
//     fetchFirstPage();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [orgId]);

//   useEffect(() => {
//     if (!orgId) return;
//     if (!clientPaged) fetchServerPage(page);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page]);

//   useEffect(() => {
//     if (!orgId) return;
//     setKeyword("");
//     fetchFirstPage();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pageSize]);

//   useEffect(() => {
//     setPage(TABLE_KEY, 1);
//     if (keyword && !clientPaged) fetchAllForSearch();
//     if (!keyword && serverModeRef.current && clientPaged) {
//       fetchFirstPage();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [keyword]);

//   const [customerSearch, setCustomerSearch] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const handleAddCustomer = () => setIsModalOpen(true);
//   const toggleModal = () => setIsModalOpen((v) => !v);

//   // ---------- MOCK ลูกค้า & แพ็กเกจ ----------
//   const mockCustomers = [
//     {
//       id: "c-0001",
//       code: "0001",
//       name: "ลูกค้า 1",
//       packages: [
//         {
//           billNo: "250013",
//           packageName: "ซักอบรีด(เครื่อง)",
//           expireAt: "2025-10-10",
//           remain: 40,
//           status: "ค้างชำระ",
//         },
//       ],
//     },
//     // ลูกค้า 2 → ไปหน้า add-record-order
//     {
//       id: "c-0002",
//       code: "0002",
//       name: "ลูกค้า 2",
//       packages: [],
//     },
//   ];

//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [isPkgModalOpen, setIsPkgModalOpen] = useState(false);

//   const thaiDate = (iso) => {
//     if (!iso && iso !== 0) return "-";
//     try {
//       const input =
//         typeof iso === "number" ? new Date(iso) : new Date(String(iso));
//       if (isNaN(input)) return String(iso);
//       return input.toLocaleDateString("th-TH", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//         timeZone: "Asia/Bangkok",
//       });
//     } catch (e) {
//       return String(iso);
//     }
//   };

//   // suggestion จากกล่องค้นหา
//   const customerSuggestions = useMemo(() => {
//     const q = customerSearch.trim();
//     if (!q) return [];
//     return mockCustomers.filter(
//       (c) =>
//         c.name.includes(q) ||
//         c.code.includes(q) ||
//         `${c.name} (${c.code})`.includes(q),
//     );
//   }, [customerSearch]);

//   // เลือกลูกค้า: ลูกค้า 2 → ไปหน้า add-record-order, ลูกค้าอื่น → เปิดโมดัลแพ็กเกจ
//   const openCustomerPackages = (customer) => {
//     if (customer.id === "c-0002" || customer.code === "0002") {
//       handleAddRecordOrder();
//       return;
//     }
//     setSelectedCustomer(customer);
//     setIsPkgModalOpen(true);
//   };

//   const goEdit = (bill) => {
//     navigate("/edit-order-bill-org", {
//       state: { bNumber: bill.bNumber, fromPath: location.pathname },
//     });
//   };

//   const handlePackageCustomer = () => {
//     navigate("/record-order-package");
//   };

//   const handleAddRecordOrder = () => {
//     navigate("/add-record-order");
//   };

//   const buildLogoUrl = (path) => {
//     if (!path) return "";

//     let base = api.defaults?.baseURL || "";
//     base = base.replace(/\/+$/, "");
//     const cleaned = path.replace(/^\/+/, "");

//     return `${base}/${cleaned}`;
//   };

//   // แปลงตัวเลขเป็นข้อความภาษาไทยแบบเงินบาท
//   const numberToThaiBahtText = (amount) => {
//     let n = Number(amount || 0);
//     if (!isFinite(n)) return "-";
//     if (n === 0) return "ศูนย์บาทถ้วน";

//     const [intPart, decPart] = n.toFixed(2).split(".");

//     const digit = [
//       "ศูนย์",
//       "หนึ่ง",
//       "สอง",
//       "สาม",
//       "สี่",
//       "ห้า",
//       "หก",
//       "เจ็ด",
//       "แปด",
//       "เก้า",
//     ];
//     const unit = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

//     const readThaiNumber = (numStr) => {
//       numStr = numStr.replace(/^0+/, "") || "0";
//       if (numStr === "0") return "";

//       if (numStr.length > 6) {
//         const head = numStr.slice(0, numStr.length - 6);
//         const tail = numStr.slice(-6);
//         return readThaiNumber(head) + "ล้าน" + readThaiNumber(tail);
//       }

//       let txt = "";
//       const len = numStr.length;
//       for (let i = 0; i < len; i++) {
//         const d = parseInt(numStr[i], 10);
//         if (d === 0) continue;

//         const pos = len - i - 1;
//         if (pos === 0) {
//           if (len > 1 && d === 1) txt += "เอ็ด";
//           else txt += digit[d];
//         } else if (pos === 1) {
//           if (d === 1) txt += "สิบ";
//           else if (d === 2) txt += "ยี่สิบ";
//           else txt += digit[d] + "สิบ";
//         } else {
//           txt += digit[d] + unit[pos];
//         }
//       }
//       return txt;
//     };

//     const intText = readThaiNumber(intPart) || "ศูนย์";
//     if (decPart === "00") return intText + "บาทถ้วน";

//     const decText = readThaiNumber(decPart);
//     return intText + "บาท" + decText + "สตางค์";
//   };

//   const handlePrint = async (bill) => {
//     if (!bill?.bNumber) return;

//     try {
//       const res = await api.get(API_GETBILLDETAIL, {
//         params: { BNUMBER: bill.bNumber, ORGID: orgId, BRID: brId },
//       });

//       const detail = res.data?.data;
//       if (!detail) {
//         alert("ไม่พบข้อมูลบิล");
//         return;
//       }

//       const c = detail.customer || {};
//       const items = detail.items || [];

//       const isCorp = c.cmType === "นิติบุคคล";

//       const buyerName = isCorp
//         ? c.cmBillNameTH || c.cmName || "-"
//         : c.cmName || "-";

//       const baseAddr = isCorp ? c.cmBillAddr || c.cmAddr : c.cmAddr;
//       const subDistrict = isCorp
//         ? c.cmBillSubDistrict || c.cmSubDistrict
//         : c.cmSubDistrict;
//       const district = isCorp ? c.cmBillDistrict || c.cmDistrict : c.cmDistrict;
//       const province = isCorp ? c.cmBillProvince || c.cmProvince : c.cmProvince;
//       const zipcode = isCorp ? c.cmBillZipcode : c.cmZipcode;

//       const buyerPhone = isCorp
//         ? c.cmBillMobile || c.cmBillPhone
//         : c.cmMobile || c.cmPhone;
//       const buyerEmail = isCorp ? c.cmBillEmail : c.cmEmail;

//       const buyerAddress =
//         `${baseAddr || ""} ต.${subDistrict || ""} อ.${district || ""} จ.${province || ""} ${zipcode || ""}`
//           .replace(/\s+/g, " ")
//           .trim() || "-";

//       const buyerTaxId = isCorp
//         ? c.cmTaxId || "-"
//         : c.cmTaxId
//           ? c.cmTaxId
//           : "-";

//       const header = detail.billHeader || {};
//       const companyNameTh = header.nameTH || "";
//       const companyNameEn = header.nameEN || "";
//       const companyAddr = `${header.addr || ""} ต.${header.subDistrict || ""} อ.${header.district || ""} จ.${header.province || ""} ${header.zipcode || ""}`;
//       const companyContact = `เบอร์โทร : ${header.mobile || header.phone || "-"}, email : ${header.email || "-"}`;
//       const companyTaxId = header.taxId || "";

//       const billNo = detail.bNumber;
//       const billDate = thaiDate(detail.bCreatedDate || detail.bReceive);

//       const logoUrl = buildLogoUrl(header.logo);

//       const grandTotal = detail.bGrandTotal ?? 0;
//       const amountText = numberToThaiBahtText(grandTotal);

//       const html = `
//       <html lang="th">
//       <head>
//         <meta charset="utf-8" />
//         <title>ใบเสร็จรับเงิน ${billNo}</title>
//         <link href="https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap" rel="stylesheet">
//         <style>
//           * { box-sizing: border-box; }
//           body { font-family: "Prompt", sans-serif; margin: 0; padding: 20px; }
//           .page { width: 210mm; margin: 0 auto; padding: 10mm 12mm; border: 1px solid #ddd; }
//           .row { display: flex; justify-content: space-between; }
//           .company-block { font-size: 13px; line-height: 1.4; }
//           .company-name-th { font-weight: 600; font-size: 14px; }
//           .company-name-en { font-size: 13px; }
//           .tax-box { border: 1px solid #000; padding: 6px 10px; font-size: 13px; text-align: center; min-width: 170px; }
//           .tax-box div + div { margin-top: 2px; }
//           .title-box { border: 1px solid #000; padding: 4px 12px; font-weight: 600; text-align: center; margin: 14px auto 12px; display: inline-block; font-size: 14px; }
//           .info-box { font-size: 13px; margin-bottom: 12px; }
//           .info-row { display: flex; margin-bottom: 4px; }
//           .info-label { font-size: 13px; width: 80px; flex-shrink: 0; white-space: nowrap; }
//           table { width: 100%; border-collapse: collapse; font-size: 13px; }
//           th, td { border: 1px solid #000; padding: 4px 6px; }
//           th { text-align: center; }
//           td.num { text-align: center; }
//           td.right { text-align: right; }
//           .summary-table { margin-top: 0; float: right; width: 35%; }
//           .summary-table td { border-left: none; border-right: none; }
//           .summary-table td.label { text-align: right; }
//           .summary-table td.value { text-align: right; width: 90px; }
//           .amount-text-box { border: 1px solid #000; padding: 6px 8px; margin-top: 12px; font-size: 13px; text-align: center; }
//           .sign-row { display: flex; justify-content: space-between; margin-top: 30px; font-size: 13px; }
//           .sign-box { width: 45%; text-align: center; }
//           .note { font-size: 12px; margin-top: 12px; }
//           .note-green { color: #059669; margin-top: 10px; font-size: 13px; }
//           @media print {
//             body { margin: 0; padding: 0; }
//             .page { border: none; margin: 0; width: auto; padding: 10mm 12mm; }
//           }
//         </style>
//       </head>
//       <body>
//         <div class="page">
//           <div class="row">
//             <div class="company-block" style="display:flex; align-items:flex-start; gap:15px;">
//               ${logoUrl ? `<img src="${logoUrl}" style="height:45px; width:auto; object-fit:contain;" />` : ""}
//               <div>
//                 <div class="company-name-th">
//                   ${companyNameTh} ${companyNameEn ? `(${companyNameEn})` : ""}
//                 </div>
//                 <div>เลขผู้เสียภาษี: ${companyTaxId}</div>
//                 <div>${companyAddr}</div>
//                 <div>${companyContact}</div>
//               </div>
//             </div>
//             <div>
//               <div class="tax-box">
//                 <div>เลขที่บิล ${billNo}</div>
//                 <div>วันที่ : ${billDate}</div>
//               </div>
//             </div>
//           </div>

//           <div style="text-align:center;">
//             <div class="title-box">ใบเสร็จรับเงิน/ใบกำกับภาษี (ต้นฉบับ)</div>
//           </div>

//           <div class="info-box">
//             <div class="info-row">
//               <div class="info-label">ลูกค้า :</div>
//               <div>${buyerName}</div>
//             </div>
//             <div class="info-row">
//               <div class="info-label">ที่อยู่ :</div>
//               <div>${buyerAddress}</div>
//             </div>
//             <div class="info-row">
//               <div class="info-label">เบอร์โทร :</div>
//               <div>${buyerPhone || "-"}</div>
//             </div>
//             ${
//               buyerEmail
//                 ? `
//                 <div class="info-row">
//                   <div class="info-label">email:</div>
//                   <div>${buyerEmail}</div>
//                 </div>
//               `
//                 : ""
//             }
//             <div class="info-row">
//               <div class="info-label">เลขผู้เสียภาษี:</div>
//               <div>${buyerTaxId}</div>
//             </div>
//           </div>

//           <table>
//             <thead>
//               <tr>
//                 <th style="width:40px;">ลำดับ</th>
//                 <th>รายการ</th>
//                 <th style="width:80px;">จำนวน</th>
//                 <th style="width:110px;">ราคาต่อหน่วย</th>
//                 <th style="width:120px;">จำนวนเงิน (บาท)</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${
//                 items.length === 0
//                   ? `
//                   <tr>
//                     <td colspan="5" style="height:260px;"></td>
//                   </tr>`
//                   : items
//                       .map(
//                         (it, idx) => `
//                     <tr>
//                       <td class="num">${idx + 1}</td>
//                       <td>${it.pdName || ""}</td>
//                       <td class="num">${it.qty ?? ""}</td>
//                       <td class="right">${(it.price ?? 0).toLocaleString()}</td>
//                       <td class="right">${(it.lineTotal ?? 0).toLocaleString()}</td>
//                     </tr>
//                   `,
//                       )
//                       .join("") +
//                     Array.from({ length: Math.max(0, 10 - items.length) })
//                       .map(
//                         () => `
//                     <tr>
//                       <td style="height:22px;"></td>
//                       <td></td><td></td><td></td><td></td>
//                     </tr>`,
//                       )
//                       .join("")
//               }
//             </tbody>
//           </table>

//           <table class="summary-table">
//             <tr><td class="label">รวมเงิน</td><td class="value">${(detail.bTotal ?? 0).toLocaleString()}</td></tr>
//             <tr><td class="label">ภาษีมูลค่าเพิ่ม 7 %</td><td class="value">${(detail.bVat ?? 0).toLocaleString()}</td></tr>
//             <tr><td class="label">ยอดเงินสุทธิ</td><td class="value">${grandTotal.toLocaleString()}</td></tr>
//           </table>

//           <div style="clear:both;"></div>

//           <div class="amount-text-box">${amountText}</div>

//           <div class="note-green">ได้รับสินค้าถูกต้องและเรียบร้อยแล้ว</div>

//           <div class="sign-row">
//             <div class="sign-box">
//               <div>ลงชื่อ .............................................................................. (ผู้ชำระเงิน)</div>
//               <div>วันที่ ............/............/................</div>
//             </div>
//             <div class="sign-box">
//               <div>ลงชื่อ .............................................................................. (ผู้รับเงิน)</div>
//               <div>วันที่ ............/............/................</div>
//             </div>
//           </div>

//           <div class="note">
//             หมายเหตุ : ใบเสร็จนี้ถูกต้องสมบูรณ์ต่อเมื่อได้รับชำระเงินไว้เป็นที่เรียบร้อยแล้ว
//           </div>
//         </div>

//         <script>
//           window.onload = function () { window.print(); };
//         </script>
//       </body>
//       </html>
//     `;

//       const printWin = window.open("", "_blank");
//       printWin.document.open();
//       printWin.document.write(html);
//       printWin.document.close();
//     } catch (err) {
//       console.error("handlePrint error:", err);
//       alert("ไม่สามารถเปิดหน้าใบเสร็จได้");
//     }
//   };

//   // ===== POS =====
//   const [posPreview, setPosPreview] = useState(null);
//   const [isPosModalOpen, setIsPosModalOpen] = useState(false);

//   async function sendToPosPrinter(bytes) {
//     console.log("ESC/POS bytes to print:", bytes);
//   }

//   const handlePrintPOS = async (bill) => {
//     if (!bill?.bNumber) return;

//     try {
//       const res = await api.get(API_GETBILLDETAIL, {
//         params: { BNUMBER: bill.bNumber, ORGID: orgId, BRID: brId },
//       });

//       const detail = res.data?.data;
//       if (!detail) {
//         alert("ไม่พบข้อมูลบิล");
//         return;
//       }

//       const c = detail.customer || {};
//       const items = detail.items || [];

//       const isCorp = c.cmType === "นิติบุคคล";
//       const buyerName = isCorp
//         ? c.cmBillNameTH || c.cmName || "-"
//         : c.cmName || "-";

//       const baseAddr = isCorp ? c.cmBillAddr || c.cmAddr : c.cmAddr;
//       const subDistrict = isCorp
//         ? c.cmBillSubDistrict || c.cmSubDistrict
//         : c.cmSubDistrict;
//       const district = isCorp ? c.cmBillDistrict || c.cmDistrict : c.cmDistrict;
//       const province = isCorp ? c.cmBillProvince || c.cmProvince : c.cmProvince;
//       const zipcode = isCorp ? c.cmBillZipcode : c.cmZipcode;

//       const buyerAddress =
//         `${baseAddr || ""} ต.${subDistrict || ""} อ.${district || ""} จ.${province || ""} ${zipcode || ""}`
//           .replace(/\s+/g, " ")
//           .trim() || "-";

//       const buyerPhone = isCorp
//         ? c.cmBillMobile || c.cmBillPhone
//         : c.cmMobile || c.cmPhone;
//       const buyerEmail = isCorp ? c.cmBillEmail : c.cmEmail;
//       const buyerTaxId = isCorp
//         ? c.cmTaxId || "-"
//         : c.cmTaxId
//           ? c.cmTaxId
//           : "-";

//       const header = detail.billHeader || {};

//       const orgLogo = buildLogoUrl(header.logo);
//       const orgAddr =
//         `${header.addr || ""} ต.${header.subDistrict || ""} อ.${header.district || ""} จ.${header.province || ""} ${header.zipcode || ""}`
//           .replace(/\s+/g, " ")
//           .trim();

//       const orgContact = `โทร : ${header.mobile || header.phone || "-"} ,  email : ${header.email || "-"}`;

//       const billNo = detail.bNumber;
//       const billDate = thaiDate(detail.bCreatedDate || detail.bReceive);

//       setPosPreview({
//         org: {
//           logo: orgLogo,
//           nameTH: header.nameTH || "",
//           nameEN: header.nameEN || "",
//           taxId: header.taxId || "",
//           addr: orgAddr,
//           contact: orgContact,
//         },
//         billNo,
//         billDate,
//         buyerName,
//         buyerAddress,
//         buyerPhone,
//         buyerEmail,
//         buyerTaxId,
//         items,
//         total: detail.bTotal ?? 0,
//         vat: detail.bVat ?? 0,
//         grand: detail.bGrandTotal ?? 0,
//       });

//       setIsPosModalOpen(true);
//     } catch (err) {
//       console.error("handlePrintPOS error:", err);
//       alert("ไม่สามารถโหลดข้อมูลบิลสำหรับพิมพ์ POS ได้");
//     }
//   };

//   const confirmPrintPOS = async () => {
//     if (!posPreview) return;
//     try {
//       const {
//         org,
//         billNo,
//         billDate,
//         buyerName,
//         buyerAddress,
//         buyerPhone,
//         buyerEmail,
//         buyerTaxId,
//         items,
//         total,
//         vat,
//         grand,
//       } = posPreview;

//       const width = 32;

//       const fmtMoney = (n) => Number(n || 0).toFixed(2);

//       const encoder = new EscPosEncoder({ width });
//       let e = encoder.initialize();

//       if (org.nameTH) {
//         e = e.align("center").bold(true).line(org.nameTH).bold(false);
//       }
//       if (org.nameEN) e = e.align("center").line(org.nameEN);
//       if (org.addr) e = e.align("center").line(org.addr).align("left");

//       e = e
//         .newline()
//         .line(`เลขที่บิล : ${billNo}`)
//         .line(`วันที่    : ${billDate}`)
//         .line("-".repeat(width));

//       e = e
//         .line(`ลูกค้า   : ${buyerName}`)
//         .line(`ที่อยู่   : ${buyerAddress}`)
//         .line(`โทร      : ${buyerPhone || "-"}`)
//         .line(`ภาษี    : ${buyerTaxId}`)
//         .line("-".repeat(width));

//       if (items.length === 0) {
//         e = e.line("(ไม่มีรายการสินค้า)");
//       } else {
//         items.forEach((it) => {
//           const name = (it.pdName || "").toString();
//           const qty = Number(it.qty || 0);
//           const price = Number(it.price || 0);
//           const lineTotal = Number(
//             it.lineTotal != null ? it.lineTotal : qty * price,
//           );

//           const itemName = name.length > width ? name.slice(0, width) : name;
//           e = e.line(itemName);

//           const qtyStr = qty.toString();
//           const priceStr = fmtMoney(price);
//           const totalStr = fmtMoney(lineTotal);

//           const left = `${qtyStr} x ${priceStr}`;
//           const spaces =
//             width - left.length - totalStr.length > 0
//               ? width - left.length - totalStr.length
//               : 1;

//           e = e.line(left + " ".repeat(spaces) + totalStr);
//         });
//       }

//       e = e.line("-".repeat(width));

//       const addSummaryLine = (label, value) => {
//         const vStr = fmtMoney(value);
//         const spaces =
//           width - label.length - vStr.length > 0
//             ? width - label.length - vStr.length
//             : 1;
//         e = e.line(label + " ".repeat(spaces) + vStr);
//       };

//       addSummaryLine("รวม", total);
//       addSummaryLine("ภาษี 7%", vat);
//       addSummaryLine("ยอดสุทธิ", grand);

//       e = e
//         .line("-".repeat(width))
//         .align("center")
//         .line("ขอบคุณที่ใช้บริการ")
//         .newline()
//         .newline()
//         .cut();

//       const bytes = e.encode();
//       await sendToPosPrinter(bytes);

//       setIsPosModalOpen(false);
//     } catch (err) {
//       console.error("confirmPrintPOS error:", err);
//       alert("พิมพ์ POS ไม่สำเร็จ");
//     }
//   };

//   return (
//     <>
//       <Header />
//       <Container className="mt--7" fluid>
//         <Card>
//           <CardHeader
//             className="bg-white border-0"
//             style={{ padding: "1.25rem 1.5rem" }}
//           >
//             <Row className="align-items-center">
//               <Col xs="12" lg="6">
//                 <h6 className="mb-0">รายการบิล</h6>
//               </Col>
//             </Row>
//           </CardHeader>

//           <CardBody
//             className="border-0"
//             style={{ backgroundColor: "#f7f9fb", padding: "1.5rem 1.75rem" }}
//           >
//             {/* Toolbar: page-size + search */}
//             <div className="mb-3">
//               <Row className="align-items-center g-0">
//                 <Col
//                   xs="12"
//                   md="6"
//                   className="d-flex align-items-center flex-wrap"
//                   style={{ gap: 8 }}
//                 >
//                   <Input
//                     type="select"
//                     value={pageSize}
//                     onChange={(e) =>
//                       setPageSize(TABLE_KEY, Number(e.target.value))
//                     }
//                     style={{ width: 96 }}
//                   >
//                     {PAGE_SIZE_OPTIONS.map((n) => (
//                       <option key={n} value={n}>
//                         {n}
//                       </option>
//                     ))}
//                   </Input>
//                   <span className="text-muted">แถว/หน้า</span>
//                 </Col>

//                 <Col
//                   xs="12"
//                   md="6"
//                   className="mt-2 mt-md-0 d-flex justify-content-md-end"
//                 >
//                   <Input
//                     type="text"
//                     placeholder="ค้นหา เลขที่บิล/ลูกค้า/บริการ"
//                     value={keyword}
//                     onChange={(e) => setKeyword(e.target.value)}
//                     className="table-modern-search w-100 w-md-auto"
//                     style={{ maxWidth: 320, minWidth: 320 }}
//                   />
//                 </Col>
//               </Row>
//             </div>

//             {/* ✅ TABLE: เล็ก=เดิม, กลาง/ใหญ่=แบบ Product */}
//             {isSmall ? (
//               <div className="table-responsive">
//                 <Table
//                   responsive
//                   hover
//                   borderless
//                   className="table table-modern mb-0 bill-table"
//                 >
//                   <thead className="thead-colored">
//                     <tr>
//                       <th>เลขที่บิล</th>
//                       <th>ลูกค้า</th>
//                       <th>บริการ</th>
//                       <th>วันที่รับ</th>
//                       <th>วันที่ส่ง</th>
//                       <th>สถานะ</th>
//                       <th className="text-center">จัดการ</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {isLoading && (
//                       <tr>
//                         <td colSpan={7} className="text-center py-4">
//                           กำลังโหลดข้อมูล...
//                         </td>
//                       </tr>
//                     )}

//                     {!isLoading && filteredTotal === 0 && (
//                       <tr>
//                         <td colSpan="7" className="text-center text-muted">
//                           ไม่พบข้อมูลบิล
//                         </td>
//                       </tr>
//                     )}

//                     {!isLoading &&
//                       displayRows.map((r) => (
//                         <tr key={r.bNumber}>
//                           <td data-th="เลขที่บิล">{r.bNumber}</td>
//                           <td data-th="ลูกค้า">
//                             ({r.cmCode}) {r.cmName}
//                           </td>
//                           <td data-th="บริการ">{r.svName}</td>
//                           <td data-th="วันที่รับ">{thaiDate(r.bReceive)}</td>
//                           <td data-th="วันที่ส่ง">{thaiDate(r.bDuedate)}</td>
//                           <td data-th="สถานะ">
//                             <span className="text-warning font-weight-bold text-center">
//                               -
//                             </span>
//                           </td>
//                           <td className="text-center" data-th="จัดการ">
//                             <Button
//                               color="warning"
//                               size="sm"
//                               className="mr-2"
//                               onClick={() => goEdit(r)}
//                             >
//                               แก้ไข
//                             </Button>
//                             <Button
//                               color="secondary"
//                               size="sm"
//                               className="mr-2"
//                               onClick={() => handlePrint(r)}
//                             >
//                               พิมพ์ PDF
//                             </Button>
//                             <Button
//                               color="secondary"
//                               size="sm"
//                               className="mr-2"
//                               onClick={() => handlePrintPOS(r, { paper: "58" })}
//                             >
//                               พิมพ์ POS
//                             </Button>
//                           </td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </Table>
//               </div>
//             ) : (
//               <div className="zi-table-wrap">
//                 <Table responsive hover className="zi-table mb-0">
//                   <thead>
//                     <tr>
//                       <th className="text-start" style={{ width: 140 }}>
//                         เลขที่บิล
//                       </th>
//                       <th className="text-start" style={{ width: 260 }}>
//                         ลูกค้า
//                       </th>
//                       <th className="text-start">บริการ</th>
//                       <th className="text-start" style={{ width: 140 }}>
//                         วันที่รับ
//                       </th>
//                       <th className="text-start" style={{ width: 140 }}>
//                         วันที่ส่ง
//                       </th>
//                       <th className="text-start" style={{ width: 120 }}>
//                         สถานะ
//                       </th>
//                       <th className="text-end" style={{ width: 240 }}>
//                         การจัดการ
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {isLoading ? (
//                       <tr>
//                         <td colSpan={7} className="text-center text-muted py-4">
//                           กำลังโหลด...
//                         </td>
//                       </tr>
//                     ) : displayRows.length === 0 ? (
//                       <tr>
//                         <td colSpan={7} className="text-center text-muted py-4">
//                           ไม่พบข้อมูลบิล
//                         </td>
//                       </tr>
//                     ) : (
//                       displayRows.map((r) => (
//                         <tr key={r.bNumber}>
//                           <td className="text-start">{r.bNumber}</td>
//                           <td className="text-start fw-600">
//                             ({r.cmCode}) {r.cmName}
//                           </td>
//                           <td className="text-start">{r.svName}</td>
//                           <td className="text-start">{thaiDate(r.bReceive)}</td>
//                           <td className="text-start">{thaiDate(r.bDuedate)}</td>
//                           <td className="text-start">
//                             <span className="text-warning font-weight-bold">
//                               -
//                             </span>
//                           </td>
//                           <td className="text-end">
//                             <div className="d-inline-flex gap-2">
//                               <Button
//                                 size="sm"
//                                 color="warning"
//                                 onClick={() => goEdit(r)}
//                               >
//                                 แก้ไข
//                               </Button>
//                               <Button
//                                 size="sm"
//                                 color="secondary"
//                                 onClick={() => handlePrint(r)}
//                               >
//                                 พิมพ์ PDF
//                               </Button>
//                               <Button
//                                 size="sm"
//                                 color="secondary"
//                                 onClick={() =>
//                                   handlePrintPOS(r, { paper: "58" })
//                                 }
//                               >
//                                 พิมพ์ POS
//                               </Button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             )}

//             {/* Summary */}
//             <div className="d-flex justify-content-end justify-content-sm-end justify-content-center mt-2">
//               <div className="text-muted small">
//                 แสดง {(page - 1) * pageSize + (displayRows.length ? 1 : 0)}–
//                 {Math.min(page * pageSize, filteredTotal)} จากทั้งหมด{" "}
//                 {filteredTotal} รายการ
//               </div>
//             </div>

//             {/* ✅ CSS แบบ Product (จอใหญ่/กลาง) */}
//             <style>{`
//               .zi-table-wrap{
//                 background:#fff;
//                 border-radius:10px;
//                 border:1px solid rgba(0,0,0,.06);
//                 overflow:hidden;
//               }
//               .zi-table{ margin:0; }
//               .zi-table thead th{
//                 background:#f7fafc;
//                 color:#0f172a;
//                 font-weight:700;
//                 font-size:14px;
//                 border-bottom:1px solid rgba(0,0,0,.06);
//                 padding:14px 16px;
//                 white-space:nowrap;
//               }
//               .zi-table tbody td{
//                 padding:14px 16px;
//                 border-top:1px solid rgba(0,0,0,.06);
//                 vertical-align:middle;
//                 font-size:14px;
//                 color:#0f172a;
//               }
//               .zi-table tbody tr:hover{ background:#f9fbff; }
//               .fw-600{ font-weight:600; }
//             `}</style>
//           </CardBody>

//           {/* Pagination */}
//           {filteredTotal > 0 && (
//             <CardFooter
//               className="py-4"
//               style={{ position: "relative", zIndex: 10 }}
//             >
//               <div className="paging-wrap">
//                 <button
//                   className="paging-btn icon"
//                   onClick={() => setPage(TABLE_KEY, Math.max(1, page - 1))}
//                   disabled={page === 1}
//                   aria-label="Previous page"
//                 >
//                   ‹
//                 </button>

//                 {pages.map((p) => (
//                   <button
//                     key={p}
//                     className={`paging-btn ${page === p ? "active" : ""}`}
//                     onClick={() => setPage(TABLE_KEY, p)}
//                   >
//                     {p}
//                   </button>
//                 ))}

//                 <button
//                   className="paging-btn icon"
//                   onClick={() =>
//                     setPage(TABLE_KEY, Math.min(filteredPageCount, page + 1))
//                   }
//                   disabled={page === filteredPageCount}
//                   aria-label="Next page"
//                 >
//                   ›
//                 </button>
//               </div>
//             </CardFooter>
//           )}
//         </Card>
//       </Container>

//       {/* Modal: เพิ่มลูกค้า */}
//       <Modal
//         isOpen={isModalOpen}
//         toggle={toggleModal}
//         size="lg"
//         centered
//         backdrop="static"
//         keyboard={false}
//       >
//         <ModalHeader toggle={toggleModal}>เพิ่มลูกค้า</ModalHeader>
//         <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
//           <Form>
//             <div className="pl-lg-4">
//               <Row>
//                 <div className="col-12">
//                   <FormGroup>
//                     {customerTypeOptions.map((o) => {
//                       const active = form.customerType === o.value;
//                       return (
//                         <Button
//                           key={o.value}
//                           size="sm"
//                           outline={!active}
//                           color={active ? "primary" : "secondary"}
//                           className="mr-2 mb-2 rounded-pill"
//                           onClick={() =>
//                             setForm((s) => ({ ...s, customerType: o.value }))
//                           }
//                           aria-pressed={active}
//                         >
//                           {o.label}
//                         </Button>
//                       );
//                     })}
//                     <Input
//                       type="hidden"
//                       name="customerType"
//                       value={form.customerType}
//                       onChange={onChange}
//                     />
//                   </FormGroup>
//                 </div>
//               </Row>

//               <Row>
//                 <div className="col-12 col-lg-6">
//                   <FormGroup>
//                     <label className="form-control-label required">
//                       ชื่อลูกค้า
//                     </label>
//                     <Input className="form-control-alternative" type="text" />
//                   </FormGroup>
//                 </div>
//                 <div className="col-12 col-lg-6">
//                   <FormGroup>
//                     <label className="form-control-label required">
//                       เบอร์โทร
//                     </label>
//                     <Input className="form-control-alternative" type="text" />
//                   </FormGroup>
//                 </div>
//               </Row>
//             </div>

//             <div className="text-right mt-4">
//               <Button
//                 color="primary"
//                 onClick={() => {
//                   console.log("บันทึกข้อมูลลูกค้า:", form);
//                   toggleModal();
//                 }}
//                 style={{ minWidth: 120 }}
//               >
//                 บันทึก
//               </Button>
//             </div>
//           </Form>
//         </ModalBody>
//       </Modal>

//       {/* Modal: ตารางแพ็กเกจของลูกค้า */}
//       <Modal
//         isOpen={isPkgModalOpen}
//         toggle={() => setIsPkgModalOpen((v) => !v)}
//         size="lg"
//         centered
//         backdrop="static"
//         keyboard={false}
//       >
//         <ModalHeader toggle={() => setIsPkgModalOpen((v) => !v)}>
//           แพ็กเกจของลูกค้า
//         </ModalHeader>
//         <ModalBody>
//           {!selectedCustomer ? (
//             <div className="text-center text-muted">ไม่พบข้อมูลลูกค้า</div>
//           ) : (
//             <>
//               <div className="mb-3" style={{ fontWeight: 600 }}>
//                 ({selectedCustomer.code}) {selectedCustomer.name}
//               </div>
//               <Table
//                 responsive
//                 hover
//                 borderless
//                 className="table table-modern mb-0 bill-table"
//               >
//                 <thead>
//                   <tr style={{ color: "#6b7280", fontWeight: 600 }}>
//                     <th>รหัสบิล</th>
//                     <th>แพ็คเกจ</th>
//                     <th>วันหมดอายุ</th>
//                     <th>เหลือ(ชิ้น)</th>
//                     <th>ทำรายการ</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {selectedCustomer.packages.map((p) => (
//                     <tr key={p.billNo} style={{ verticalAlign: "middle" }}>
//                       <td style={{ fontWeight: 600 }}>{p.billNo}</td>
//                       <td>{p.packageName}</td>
//                       <td>{thaiDate(p.expireAt)}</td>
//                       <td>{p.remain}</td>
//                       <td className="actions">
//                         <Button
//                           style={{
//                             background: "#10a5ff",
//                             border: "none",
//                             color: "#fff",
//                             borderRadius: 10,
//                             padding: "8px 14px",
//                             fontWeight: 700,
//                           }}
//                           onClick={handlePackageCustomer}
//                         >
//                           ทำรายการ
//                         </Button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </>
//           )}
//         </ModalBody>
//       </Modal>

//       {/* Modal: POS Preview */}
//       <Modal
//         isOpen={isPosModalOpen}
//         toggle={() => setIsPosModalOpen(false)}
//         size="sm"
//         centered
//         backdrop="static"
//         keyboard={false}
//       >
//         <div className="modal-header">
//           <h5 className="modal-title">ตัวอย่างบิล POS</h5>
//           <button
//             aria-label="Close"
//             className="close"
//             type="button"
//             onClick={() => setIsPosModalOpen(false)}
//           >
//             <span aria-hidden={true}>×</span>
//           </button>
//         </div>

//         <div className="modal-body">
//           {!posPreview ? (
//             <div className="text-center text-muted">ไม่มีข้อมูลบิล</div>
//           ) : (
//             <div
//               style={{
//                 width: "58mm",
//                 margin: "0 auto",
//                 fontFamily: "monospace",
//                 fontSize: 12,
//                 background: "#fff",
//                 padding: "8px",
//                 border: "1px solid #e5e7eb",
//               }}
//             >
//               <div style={{ textAlign: "center", marginBottom: 8 }}>
//                 {posPreview.org?.nameTH && (
//                   <div style={{ fontWeight: "bold" }}>
//                     {posPreview.org.nameTH}
//                   </div>
//                 )}

//                 {posPreview.org?.taxId && (
//                   <div>เลขผู้เสียภาษี: {posPreview.org.taxId}</div>
//                 )}
//               </div>

//               <div style={{ marginBottom: 4 }}>
//                 เลขที่บิล: {posPreview.billNo}
//                 <br />
//                 วันที่: {posPreview.billDate}
//               </div>

//               <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

//               <div style={{ marginBottom: 4 }}>
//                 ลูกค้า: {posPreview.buyerName}
//                 <br />
//                 ที่อยู่: {posPreview.buyerAddress}
//               </div>

//               <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

//               {posPreview.items.map((it, idx) => (
//                 <div key={idx} style={{ marginBottom: 2 }}>
//                   <div>{it.pdName}</div>
//                   <div style={{ display: "flex" }}>
//                     <span>
//                       {it.qty} x {Number(it.price || 0).toFixed(2)}
//                     </span>
//                     <span style={{ marginLeft: "auto" }}>
//                       {Number(it.lineTotal || 0).toFixed(2)}
//                     </span>
//                   </div>
//                 </div>
//               ))}

//               <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

//               <div style={{ display: "flex" }}>
//                 <span>รวม</span>
//                 <span style={{ marginLeft: "auto" }}>
//                   {Number(posPreview.total || 0).toFixed(2)}
//                 </span>
//               </div>
//               <div style={{ display: "flex" }}>
//                 <span>ภาษี 7%</span>
//                 <span style={{ marginLeft: "auto" }}>
//                   {Number(posPreview.vat || 0).toFixed(2)}
//                 </span>
//               </div>
//               <div style={{ display: "flex", fontWeight: "bold" }}>
//                 <span>ยอดสุทธิ</span>
//                 <span style={{ marginLeft: "auto" }}>
//                   {Number(posPreview.grand || 0).toFixed(2)}
//                 </span>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="modal-footer">
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => setIsPosModalOpen(false)}
//           >
//             ยกเลิก
//           </Button>
//           <Button color="primary" size="sm" onClick={confirmPrintPOS}>
//             ยืนยันพิมพ์ POS
//           </Button>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default OrderOrgs;




import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import EscPosEncoder from "esc-pos-encoder";
import {
  Container,
  Row,
  Card,
  Button,
  Input,
  Table,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Col,
  CardBody,
  CardFooter,
} from "reactstrap";
import Header from "components/Headers/Header";
import { useSessionStore } from "../../stores/sessionStore";
import { useSettingStore } from "../../stores/settingStore";
import { api } from "../../config/middleware";
import { useTablePaging, PAGE_SIZE_OPTIONS } from "../../stores/pagingStore";
import {
  API_GETBILL,
  API_GETBILLDETAIL,
  API_GETSETTING,
  API_GETSERVICES,
} from "../../config/api";

const TABLE_KEY = "bills";

const OrderOrgs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const role = useSessionStore((s) => s.profile?.role);
  const tnId = useSessionStore((s) => s.profile?.tnId);
  const orgId = useSessionStore((s) => s.profile?.orgId);
  const brId = useSessionStore((s) => s.profile?.brId);

  const setBillMode = useSettingStore((s) => s.setBillMode);

  useEffect(() => {
    const fetchSetting = async () => {
      const res = await api.get(API_GETSETTING, {
        params: { TNID: tnId, ORGID: orgId, BRID: brId },
      });

      if (res.data?.statustext === "SUCCESS") {
        setBillMode(res.data.data.billMode);
      }
    };

    if (tnId != null && orgId != null && brId != null) {
      fetchSetting();
    }
  }, [tnId, orgId, brId, setBillMode]);

  const { page, pageSize, setPage, setPageSize } = useTablePaging(TABLE_KEY);

  // ✅ responsive: จอเล็กใช้ table เดิม
  const [isSmall, setIsSmall] = useState(window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsSmall(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // ===== data/paging state =====
  const [total, setTotal] = useState(0);
  const [rowsPage, setRowsPage] = useState([]); // server-paged: แถวของหน้าปัจจุบัน
  const [allRows, setAllRows] = useState([]); // client-paged: ดึงทั้งหมด
  const [clientPaged, setClientPaged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // search
  const [keyword, setKeyword] = useState("");
  const serverModeRef = useRef(false); // เดิมเป็น server-paged ไหม
  const reqIdRef = useRef(0);

  // modal & form (เพิ่ม/แก้ไข)
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("add"); // add | edit
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    code: "",
    name: "",
    price: 0,
    customerType: "55",
  });
  const customerTypeOptions = [
    { value: "55", label: "บุคคลธรรมดา" },
    { value: "56", label: "นิติบุคคล" },
  ];
  const [submitting, setSubmitting] = useState(false);

  const toggle = () => setIsOpen((v) => !v);

  const onChange = (e) => {
    const { name, value, type } = e.target;
    setForm((s) => ({
      ...s,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  // ===== helpers =====
  const getId = (it, i) =>
    it.pdId ?? it.ID ?? `${it.pdCode ?? it.code ?? "row"}-${i}`;

  const dedupeBy = (arr, idFn) => {
    const m = new Map();
    arr.forEach((x, i) => m.set(idFn(x, i), x));
    return [...m.values()];
  };

  const pickTotal = (d) =>
    Number(d?.total ?? d?.count ?? d?.pagination?.total ?? d?.meta?.total ?? NaN);

  const norm = (s) => (s || "").toString().toLowerCase().trim();

  // ===== base rows + filter =====
  const baseRows = clientPaged ? allRows : rowsPage;
  const filteredRows = useMemo(() => {
    const k = norm(keyword);
    if (!k) return baseRows;
    return baseRows.filter(
      (r) =>
        norm(r.bNumber ?? "").includes(k) ||
        norm(r.cmCode ?? "").includes(k) ||
        norm(r.cmName ?? "").includes(k) ||
        norm(r.svName ?? "").includes(k),
    );
  }, [baseRows, keyword]);

  const filteredTotal = filteredRows.length;
  const filteredPageCount = Math.max(1, Math.ceil(filteredTotal / pageSize));

  const displayRows = useMemo(() => {
    const start = (page - 1) * pageSize;
    return filteredRows.slice(start, start + pageSize);
  }, [filteredRows, page, pageSize]);

  const pages = useMemo(
    () => Array.from({ length: filteredPageCount }, (_, i) => i + 1),
    [filteredPageCount],
  );

  // ===== โหลดหน้าแรก =====
  const fetchFirstPage = async () => {
    if (!orgId) return;
    const myReq = ++reqIdRef.current;
    setIsLoading(true);
    setClientPaged(false);
    serverModeRef.current = false;
    setRowsPage([]);
    setAllRows([]);
    setTotal(0);
    setPage(TABLE_KEY, 1);

    try {
      const res = await api.get(API_GETBILL, {
        params: { ORGID: orgId, BRID: brId },
      });
      if (myReq !== reqIdRef.current) return;

      const raw = Array.isArray(res.data?.data) ? res.data.data : [];
      const dedup = dedupeBy(raw, getId);
      const totalFromApi = pickTotal(res.data);
      const apiLooksPaged =
        Number.isFinite(totalFromApi) && dedup.length <= pageSize;

      if (apiLooksPaged) {
        // server-paged
        setClientPaged(false);
        serverModeRef.current = true;
        setRowsPage(dedup);
        setTotal(totalFromApi);
      } else {
        // client-paged
        serverModeRef.current = false;
        setClientPaged(true);
        const all = dedupeBy(raw, getId);
        setAllRows(all);
        setTotal(all.length);
      }
    } catch (e) {
      console.error("fetchFirstPage error:", e);
    } finally {
      if (myReq === reqIdRef.current) setIsLoading(false);
    }
  };

  // ===== โหลดหน้า N (server-paged เท่านั้น) =====
  const fetchServerPage = async (nextPage) => {
    const myReq = ++reqIdRef.current;
    setIsLoading(true);
    try {
      const res = await api.get(API_GETBILL, {
        params: { ORGID: orgId, BRID: brId },
      });
      if (myReq !== reqIdRef.current) return;
      const raw = Array.isArray(res.data?.data) ? res.data.data : [];
      const dedup = dedupeBy(raw, getId);
      setRowsPage(dedup);
    } catch (e) {
      console.error("fetchServerPage error:", e);
    } finally {
      if (myReq === reqIdRef.current) setIsLoading(false);
    }
  };

  // ===== ดึงทั้งหมดเพื่อค้นหาในโหมด server =====
  const fetchAllForSearch = async () => {
    if (!orgId) return;
    const myReq = ++reqIdRef.current;
    setIsLoading(true);
    try {
      const first = await api.get(API_GETBILL, {
        params: { ORGID: orgId, BRID: brId },
      });
      if (myReq !== reqIdRef.current) return;

      const firstRows = Array.isArray(first.data?.data) ? first.data.data : [];
      const totalAll = pickTotal(first.data) || firstRows.length;
      const pagesAll = Math.max(1, Math.ceil(totalAll / pageSize));
      let all = dedupeBy(firstRows, getId);

      for (let p = 2; p <= pagesAll; p++) {
        const r = await api.get(API_GETBILL, {
          params: { ORGID: orgId, BRID: brId },
        });
        if (myReq !== reqIdRef.current) return;
        const part = Array.isArray(r.data?.data) ? r.data.data : [];
        all = dedupeBy([...all, ...part], getId);
      }

      setClientPaged(true);
      serverModeRef.current = true;
      setAllRows(all);
      setTotal(all.length);
      setPage(TABLE_KEY, 1);
    } catch (e) {
      console.error("fetchAllForSearch error:", e);
    } finally {
      if (myReq === reqIdRef.current) setIsLoading(false);
    }
  };

  // ===== lifecycle =====
  useEffect(() => {
    fetchFirstPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  useEffect(() => {
    if (!orgId) return;
    if (!clientPaged) fetchServerPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    if (!orgId) return;
    setKeyword("");
    fetchFirstPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize]);

  useEffect(() => {
    setPage(TABLE_KEY, 1);
    if (keyword && !clientPaged) fetchAllForSearch();
    if (!keyword && serverModeRef.current && clientPaged) {
      fetchFirstPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  const [customerSearch, setCustomerSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleAddCustomer = () => setIsModalOpen(true);
  const toggleModal = () => setIsModalOpen((v) => !v);

  // ---------- MOCK ลูกค้า & แพ็กเกจ ----------
  const mockCustomers = [
    {
      id: "c-0001",
      code: "0001",
      name: "ลูกค้า 1",
      packages: [
        {
          billNo: "250013",
          packageName: "ซักอบรีด(เครื่อง)",
          expireAt: "2025-10-10",
          remain: 40,
          status: "ค้างชำระ",
        },
      ],
    },
    // ลูกค้า 2 → ไปหน้า add-record-order
    {
      id: "c-0002",
      code: "0002",
      name: "ลูกค้า 2",
      packages: [],
    },
  ];

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isPkgModalOpen, setIsPkgModalOpen] = useState(false);

  const thaiDate = (iso) => {
    if (!iso && iso !== 0) return "-";
    try {
      const input =
        typeof iso === "number" ? new Date(iso) : new Date(String(iso));
      if (isNaN(input)) return String(iso);
      return input.toLocaleDateString("th-TH", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        timeZone: "Asia/Bangkok",
      });
    } catch (e) {
      return String(iso);
    }
  };

  // ===== Services map =====
  const [servicesMap, setServicesMap] = useState(new Map());

  useEffect(() => {
    const fetchServices = async () => {
      if (!orgId) return;
      try {
        const res = await api.get(API_GETSERVICES, {
          params: { ORGID: orgId, PAGE: 1, LIMIT: 9999 },
        });

        if (res.data?.statustext === "SUCCESS") {
          const arr = Array.isArray(res.data?.data) ? res.data.data : [];
          const m = new Map();
          arr.forEach((s) => m.set(Number(s.svId), s));
          setServicesMap(m);
        }
      } catch (e) {
        console.error("fetchServices error:", e);
      }
    };

    fetchServices();
  }, [orgId]);

  const getServiceInfoBySvId = (svId) => {
    if (svId == null) return null;
    return servicesMap.get(Number(svId)) || null;
  };

  const isPieceService = (serviceInfo) => {
    const t = (serviceInfo?.svType || "").trim();
    return t === "รายชิ้น";
  };

  const getServicePrice = (serviceInfo) => Number(serviceInfo?.svPrice || 0);

  // suggestion จากกล่องค้นหา
  const customerSuggestions = useMemo(() => {
    const q = customerSearch.trim();
    if (!q) return [];
    return mockCustomers.filter(
      (c) =>
        c.name.includes(q) ||
        c.code.includes(q) ||
        `${c.name} (${c.code})`.includes(q),
    );
  }, [customerSearch]);

  // เลือกลูกค้า: ลูกค้า 2 → ไปหน้า add-record-order, ลูกค้าอื่น → เปิดโมดัลแพ็กเกจ
  const openCustomerPackages = (customer) => {
    if (customer.id === "c-0002" || customer.code === "0002") {
      handleAddRecordOrder();
      return;
    }
    setSelectedCustomer(customer);
    setIsPkgModalOpen(true);
  };

  const goEdit = (bill) => {
    navigate("/edit-order-bill-org", {
      state: { bNumber: bill.bNumber, fromPath: location.pathname },
    });
  };

  const handlePackageCustomer = () => {
    navigate("/record-order-package");
  };

  const handleAddRecordOrder = () => {
    navigate("/add-record-order");
  };

  const buildLogoUrl = (path) => {
    if (!path) return "";
    let base = api.defaults?.baseURL || "";
    base = base.replace(/\/+$/, "");
    const cleaned = path.replace(/^\/+/, "");
    return `${base}/${cleaned}`;
  };

  // แปลงตัวเลขเป็นข้อความภาษาไทยแบบเงินบาท
  const numberToThaiBahtText = (amount) => {
    let n = Number(amount || 0);
    if (!isFinite(n)) return "-";
    if (n === 0) return "ศูนย์บาทถ้วน";

    const [intPart, decPart] = n.toFixed(2).split(".");

    const digit = [
      "ศูนย์",
      "หนึ่ง",
      "สอง",
      "สาม",
      "สี่",
      "ห้า",
      "หก",
      "เจ็ด",
      "แปด",
      "เก้า",
    ];
    const unit = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

    const readThaiNumber = (numStr) => {
      numStr = numStr.replace(/^0+/, "") || "0";
      if (numStr === "0") return "";

      if (numStr.length > 6) {
        const head = numStr.slice(0, numStr.length - 6);
        const tail = numStr.slice(-6);
        return readThaiNumber(head) + "ล้าน" + readThaiNumber(tail);
      }

      let txt = "";
      const len = numStr.length;
      for (let i = 0; i < len; i++) {
        const d = parseInt(numStr[i], 10);
        if (d === 0) continue;

        const pos = len - i - 1;
        if (pos === 0) {
          if (len > 1 && d === 1) txt += "เอ็ด";
          else txt += digit[d];
        } else if (pos === 1) {
          if (d === 1) txt += "สิบ";
          else if (d === 2) txt += "ยี่สิบ";
          else txt += digit[d] + "สิบ";
        } else {
          txt += digit[d] + unit[pos];
        }
      }
      return txt;
    };

    const intText = readThaiNumber(intPart) || "ศูนย์";
    if (decPart === "00") return intText + "บาทถ้วน";

    const decText = readThaiNumber(decPart);
    return intText + "บาท" + decText + "สตางค์";
  };

  // ===== PDF UI helpers (แยกรายชิ้น/แพ็คเกจ) =====
  const renderPieceItemsRows = (items) => {
    if (!items?.length) {
      return `
        <tr>
          <td colspan="5" style="height:260px;"></td>
        </tr>
      `;
    }

    const rows = items
      .map(
        (it, idx) => `
        <tr>
          <td class="num">${idx + 1}</td>
          <td>${it.pdName || ""}</td>
          <td class="num">${it.qty ?? ""}</td>
          <td class="right">${Number(it.price ?? 0).toLocaleString()}</td>
          <td class="right">${Number(it.lineTotal ?? 0).toLocaleString()}</td>
        </tr>
      `,
      )
      .join("");

    const blanks = Array.from({ length: Math.max(0, 10 - items.length) })
      .map(
        () => `
        <tr>
          <td style="height:22px;"></td>
          <td></td><td></td><td></td><td></td>
        </tr>
      `,
      )
      .join("");

    return rows + blanks;
  };

  const renderPackageRows = (serviceName, svPrice) => {
    // ✅ แพ็คเกจ/ไม่ใช่รายชิ้น: โชว์เป็น 1 แถวเดียว (ราคาแพ็คเกจ)
    return `
      <tr>
        <td class="num">1</td>
        <td>${serviceName || "-"}</td>
        <td class="num">1</td>
        <td class="right">${Number(svPrice || 0).toLocaleString()}</td>
        <td class="right">${Number(svPrice || 0).toLocaleString()}</td>
      </tr>
      ${Array.from({ length: 9 })
        .map(
          () => `
        <tr>
          <td style="height:22px;"></td>
          <td></td><td></td><td></td><td></td>
        </tr>
      `,
        )
        .join("")}
    `;
  };

  const handlePrint = async (bill) => {
    if (!bill?.bNumber) return;

    try {
      const res = await api.get(API_GETBILLDETAIL, {
        params: { BNUMBER: bill.bNumber, ORGID: orgId, BRID: brId },
      });

      const detail = res.data?.data;
      if (!detail) {
        alert("ไม่พบข้อมูลบิล");
        return;
      }

      const serviceInfo = getServiceInfoBySvId(detail.svId);
      const piece = isPieceService(serviceInfo);
      const svPrice = getServicePrice(serviceInfo);
      const serviceNameForPackage =
        serviceInfo?.svName || detail.svName || "แพ็คเกจ";

      const c = detail.customer || {};
      const items = detail.items || [];

      const isCorp = c.cmType === "นิติบุคคล";

      const buyerName = isCorp
        ? c.cmBillNameTH || c.cmName || "-"
        : c.cmName || "-";

      const baseAddr = isCorp ? c.cmBillAddr || c.cmAddr : c.cmAddr;
      const subDistrict = isCorp
        ? c.cmBillSubDistrict || c.cmSubDistrict
        : c.cmSubDistrict;
      const district = isCorp ? c.cmBillDistrict || c.cmDistrict : c.cmDistrict;
      const province = isCorp ? c.cmBillProvince || c.cmProvince : c.cmProvince;
      const zipcode = isCorp ? c.cmBillZipcode : c.cmZipcode;

      const buyerPhone = isCorp
        ? c.cmBillMobile || c.cmBillPhone
        : c.cmMobile || c.cmPhone;
      const buyerEmail = isCorp ? c.cmBillEmail : c.cmEmail;

      const buyerAddress =
        `${baseAddr || ""} ต.${subDistrict || ""} อ.${district || ""} จ.${province || ""} ${zipcode || ""}`
          .replace(/\s+/g, " ")
          .trim() || "-";

      const buyerTaxId = isCorp
        ? c.cmTaxId || "-"
        : c.cmTaxId
          ? c.cmTaxId
          : "-";

      const header = detail.billHeader || {};
      const companyNameTh = header.nameTH || "";
      const companyNameEn = header.nameEN || "";
      const companyAddr = `${header.addr || ""} ต.${header.subDistrict || ""} อ.${header.district || ""} จ.${header.province || ""} ${header.zipcode || ""}`;
      const companyContact = `เบอร์โทร : ${header.mobile || header.phone || "-"}, email : ${header.email || "-"}`;
      const companyTaxId = header.taxId || "";

      const billNo = detail.bNumber;
      const billDate = thaiDate(detail.bCreatedDate || detail.bReceive);

      const logoUrl = buildLogoUrl(header.logo);

      // ✅ แยก UI: รายชิ้น vs แพ็คเกจ
      const itemsBodyHtml = piece
        ? renderPieceItemsRows(items)
        : renderPackageRows(serviceNameForPackage, svPrice);

      const summaryHtml = piece
        ? `
          <table class="summary-table">
            <tr><td class="label">รวมเงิน</td><td class="value">${Number(detail.bTotal ?? 0).toLocaleString()}</td></tr>
            <tr><td class="label">ภาษีมูลค่าเพิ่ม 7 %</td><td class="value">${Number(detail.bVat ?? 0).toLocaleString()}</td></tr>
            <tr><td class="label">ยอดเงินสุทธิ</td><td class="value">${Number(detail.bGrandTotal ?? 0).toLocaleString()}</td></tr>
          </table>
        `
        : `
          <table class="summary-table">
            <tr><td class="label">ราคาแพ็คเกจ</td><td class="value">${Number(svPrice ?? 0).toLocaleString()}</td></tr>
            <tr><td class="label">ภาษีมูลค่าเพิ่ม</td><td class="value">-</td></tr>
            <tr><td class="label">ยอดเงินสุทธิ</td><td class="value">${Number(svPrice ?? 0).toLocaleString()}</td></tr>
          </table>
        `;

      // ✅ กล่องจำนวนเงินเป็นข้อความ: รายชิ้นใช้ grandTotal, แพ็คเกจใช้ svPrice
      const amountText = piece
        ? numberToThaiBahtText(detail.bGrandTotal ?? 0)
        : numberToThaiBahtText(svPrice ?? 0);

      const html = `
      <html lang="th">
      <head>
        <meta charset="utf-8" />
        <title>ใบเสร็จรับเงิน ${billNo}</title>
        <link href="https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap" rel="stylesheet">
        <style>
          * { box-sizing: border-box; }
          body { font-family: "Prompt", sans-serif; margin: 0; padding: 20px; }
          .page { width: 210mm; margin: 0 auto; padding: 10mm 12mm; border: 1px solid #ddd; }
          .row { display: flex; justify-content: space-between; }
          .company-block { font-size: 13px; line-height: 1.4; }
          .company-name-th { font-weight: 600; font-size: 14px; }
          .company-name-en { font-size: 13px; }
          .tax-box { border: 1px solid #000; padding: 6px 10px; font-size: 13px; text-align: center; min-width: 170px; }
          .tax-box div + div { margin-top: 2px; }
          .title-box { border: 1px solid #000; padding: 4px 12px; font-weight: 600; text-align: center; margin: 14px auto 12px; display: inline-block; font-size: 14px; }
          .info-box { font-size: 13px; margin-bottom: 12px; }
          .info-row { display: flex; margin-bottom: 4px; }
          .info-label { font-size: 13px; width: 80px; flex-shrink: 0; white-space: nowrap; }
          table { width: 100%; border-collapse: collapse; font-size: 13px; }
          th, td { border: 1px solid #000; padding: 4px 6px; }
          th { text-align: center; }
          td.num { text-align: center; }
          td.right { text-align: right; }
          .summary-table { margin-top: 0; float: right; width: 35%; }
          .summary-table td { border-left: none; border-right: none; }
          .summary-table td.label { text-align: right; }
          .summary-table td.value { text-align: right; width: 90px; }
          .amount-text-box { border: 1px solid #000; padding: 6px 8px; margin-top: 12px; font-size: 13px; text-align: center; }
          .sign-row { display: flex; justify-content: space-between; margin-top: 30px; font-size: 13px; }
          .sign-box { width: 45%; text-align: center; }
          .note { font-size: 12px; margin-top: 12px; }
          .note-green { color: #059669; margin-top: 10px; font-size: 13px; }
          .badge { display:inline-block; padding:3px 8px; border:1px solid #000; border-radius:999px; font-size:12px; }
          @media print {
            body { margin: 0; padding: 0; }
            .page { border: none; margin: 0; width: auto; padding: 10mm 12mm; }
          }
        </style>
      </head>
      <body>
        <div class="page">
          <div class="row">
            <div class="company-block" style="display:flex; align-items:flex-start; gap:15px;">
              ${logoUrl ? `<img src="${logoUrl}" style="height:45px; width:auto; object-fit:contain;" />` : ""}
              <div>
                <div class="company-name-th">
                  ${companyNameTh} ${companyNameEn ? `(${companyNameEn})` : ""}
                </div>
                <div>เลขผู้เสียภาษี: ${companyTaxId}</div>
                <div>${companyAddr}</div>
                <div>${companyContact}</div>
              </div>
            </div>
            <div>
              <div class="tax-box">
                <div>เลขที่บิล ${billNo}</div>
                <div>วันที่ : ${billDate}</div>
              </div>
            </div>
          </div>

          <div style="text-align:center;">
            <div class="title-box">ใบเสร็จรับเงิน/ใบกำกับภาษี (ต้นฉบับ)</div>
            <div style="margin-top:6px;">
              ${
                piece
                  ? `<span class="badge">บริการ: รายชิ้น</span>`
                  : `<span class="badge">บริการ: แพ็คเกจ</span>`
              }
            </div>
          </div>

          <div class="info-box">
            <div class="info-row">
              <div class="info-label">ลูกค้า :</div>
              <div>${buyerName}</div>
            </div>
            <div class="info-row">
              <div class="info-label">ที่อยู่ :</div>
              <div>${buyerAddress}</div>
            </div>
            <div class="info-row">
              <div class="info-label">เบอร์โทร :</div>
              <div>${buyerPhone || "-"}</div>
            </div>
            ${
              buyerEmail
                ? `
                <div class="info-row">
                  <div class="info-label">email:</div>
                  <div>${buyerEmail}</div>
                </div>
              `
                : ""
            }
            <div class="info-row">
              <div class="info-label">เลขผู้เสียภาษี:</div>
              <div>${buyerTaxId}</div>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th style="width:40px;">ลำดับ</th>
                <th>รายการ</th>
                <th style="width:80px;">จำนวน</th>
                <th style="width:110px;">ราคาต่อหน่วย</th>
                <th style="width:120px;">จำนวนเงิน (บาท)</th>
              </tr>
            </thead>
            <tbody>
              ${itemsBodyHtml}
            </tbody>
          </table>

          ${summaryHtml}

          <div style="clear:both;"></div>

          <div class="amount-text-box">${amountText}</div>

          <div class="note-green">ได้รับสินค้าถูกต้องและเรียบร้อยแล้ว</div>

          <div class="sign-row">
            <div class="sign-box">
              <div>ลงชื่อ .............................................................................. (ผู้ชำระเงิน)</div>
              <div>วันที่ ............/............/................</div>
            </div>
            <div class="sign-box">
              <div>ลงชื่อ .............................................................................. (ผู้รับเงิน)</div>
              <div>วันที่ ............/............/................</div>
            </div>
          </div>

          <div class="note">
            หมายเหตุ : ใบเสร็จนี้ถูกต้องสมบูรณ์ต่อเมื่อได้รับชำระเงินไว้เป็นที่เรียบร้อยแล้ว
          </div>
        </div>

        <script>
          window.onload = function () { window.print(); };
        </script>
      </body>
      </html>
    `;

      const printWin = window.open("", "_blank");
      printWin.document.open();
      printWin.document.write(html);
      printWin.document.close();
    } catch (err) {
      console.error("handlePrint error:", err);
      alert("ไม่สามารถเปิดหน้าใบเสร็จได้");
    }
  };

  // ===== POS =====
  const [posPreview, setPosPreview] = useState(null);
  const [isPosModalOpen, setIsPosModalOpen] = useState(false);

  async function sendToPosPrinter(bytes) {
    console.log("ESC/POS bytes to print:", bytes);
  }

  const handlePrintPOS = async (bill) => {
    if (!bill?.bNumber) return;

    try {
      const res = await api.get(API_GETBILLDETAIL, {
        params: { BNUMBER: bill.bNumber, ORGID: orgId, BRID: brId },
      });

      const detail = res.data?.data;
      if (!detail) {
        alert("ไม่พบข้อมูลบิล");
        return;
      }

      const serviceInfo = getServiceInfoBySvId(detail.svId);
      const piece = isPieceService(serviceInfo);
      const svPrice = getServicePrice(serviceInfo);

      const c = detail.customer || {};
      const items = detail.items || [];

      const isCorp = c.cmType === "นิติบุคคล";
      const buyerName = isCorp
        ? c.cmBillNameTH || c.cmName || "-"
        : c.cmName || "-";

      const baseAddr = isCorp ? c.cmBillAddr || c.cmAddr : c.cmAddr;
      const subDistrict = isCorp
        ? c.cmBillSubDistrict || c.cmSubDistrict
        : c.cmSubDistrict;
      const district = isCorp ? c.cmBillDistrict || c.cmDistrict : c.cmDistrict;
      const province = isCorp ? c.cmBillProvince || c.cmProvince : c.cmProvince;
      const zipcode = isCorp ? c.cmBillZipcode : c.cmZipcode;

      const buyerAddress =
        `${baseAddr || ""} ต.${subDistrict || ""} อ.${district || ""} จ.${province || ""} ${zipcode || ""}`
          .replace(/\s+/g, " ")
          .trim() || "-";

      const buyerPhone = isCorp
        ? c.cmBillMobile || c.cmBillPhone
        : c.cmMobile || c.cmPhone;
      const buyerEmail = isCorp ? c.cmBillEmail : c.cmEmail;
      const buyerTaxId = isCorp
        ? c.cmTaxId || "-"
        : c.cmTaxId
          ? c.cmTaxId
          : "-";

      const header = detail.billHeader || {};

      const orgLogo = buildLogoUrl(header.logo);
      const orgAddr =
        `${header.addr || ""} ต.${header.subDistrict || ""} อ.${header.district || ""} จ.${header.province || ""} ${header.zipcode || ""}`
          .replace(/\s+/g, " ")
          .trim();

      const orgContact = `โทร : ${header.mobile || header.phone || "-"} ,  email : ${header.email || "-"}`;

      const billNo = detail.bNumber;
      const billDate = thaiDate(detail.bCreatedDate || detail.bReceive);

      setPosPreview({
        org: {
          logo: orgLogo,
          nameTH: header.nameTH || "",
          nameEN: header.nameEN || "",
          taxId: header.taxId || "",
          addr: orgAddr,
          contact: orgContact,
        },
        billNo,
        billDate,
        buyerName,
        buyerAddress,
        buyerPhone,
        buyerEmail,
        buyerTaxId,
        items,
        service: {
          svId: detail.svId,
          svType: serviceInfo?.svType || detail.svType || "",
          svName: serviceInfo?.svName || detail.svName || "",
          svPrice,
          isPiece: piece,
        },
        total: detail.bTotal ?? 0,
        vat: detail.bVat ?? 0,
        grand: detail.bGrandTotal ?? 0,
      });

      setIsPosModalOpen(true);
    } catch (err) {
      console.error("handlePrintPOS error:", err);
      alert("ไม่สามารถโหลดข้อมูลบิลสำหรับพิมพ์ POS ได้");
    }
  };

  const confirmPrintPOS = async () => {
    if (!posPreview) return;

    try {
      const {
        org,
        billNo,
        billDate,
        buyerName,
        buyerAddress,
        buyerPhone,
        buyerEmail,
        buyerTaxId,
        items,
        total,
        vat,
        grand,
        service,
      } = posPreview;

      const width = 32;
      const fmtMoney = (n) => Number(n || 0).toFixed(2);

      const encoder = new EscPosEncoder({ width });
      let e = encoder.initialize();

      if (org.nameTH) {
        e = e.align("center").bold(true).line(org.nameTH).bold(false);
      }
      if (org.nameEN) e = e.align("center").line(org.nameEN);
      if (org.addr) e = e.align("center").line(org.addr).align("left");

      e = e
        .newline()
        .line(`เลขที่บิล : ${billNo}`)
        .line(`วันที่    : ${billDate}`)
        .line("-".repeat(width));

      e = e
        .line(`ลูกค้า   : ${buyerName}`)
        .line(`ที่อยู่   : ${buyerAddress}`)
        .line(`โทร      : ${buyerPhone || "-"}`)
        .line(`ภาษี    : ${buyerTaxId}`)
        .line("-".repeat(width));

      const addSummaryLine = (label, value) => {
        const vStr = fmtMoney(value);
        const spaces = Math.max(1, width - label.length - vStr.length);
        e = e.line(label + " ".repeat(spaces) + vStr);
      };

      // ✅ แยก UI POS: รายชิ้น vs แพ็คเกจ
      if (service?.isPiece) {
        // ===== รายชิ้น: พิมพ์รายการ item ตามเดิม =====
        if (!items?.length) {
          e = e.line("(ไม่มีรายการสินค้า)");
        } else {
          items.forEach((it) => {
            const name = (it.pdName || "").toString();
            const qty = Number(it.qty || 0);
            const price = Number(it.price || 0);
            const lineTotal = Number(
              it.lineTotal != null ? it.lineTotal : qty * price,
            );

            const itemName = name.length > width ? name.slice(0, width) : name;
            e = e.line(itemName);

            const left = `${qty} x ${fmtMoney(price)}`;
            const right = fmtMoney(lineTotal);
            const spaces = Math.max(1, width - left.length - right.length);
            e = e.line(left + " ".repeat(spaces) + right);
          });
        }

        e = e.line("-".repeat(width));
        addSummaryLine("รวม", total);
        addSummaryLine("ภาษี 7%", vat);
        addSummaryLine("ยอดสุทธิ", grand);
      } else {
        // ===== แพ็คเกจ/ไม่ใช่รายชิ้น: UI ใหม่ =====
        const pkgName = (service?.svName || "").trim() || "แพ็คเกจ";
        const pkgPrice = Number(service?.svPrice || 0);

        e = e.align("center").bold(true).line("รายการแพ็คเกจ").bold(false);
        e = e.align("left").line(pkgName);
        e = e.line("-".repeat(width));

        addSummaryLine("ราคาแพ็คเกจ", pkgPrice);
        addSummaryLine("ภาษี", 0);
        addSummaryLine("ยอดสุทธิ", pkgPrice);
      }

      e = e
        .line("-".repeat(width))
        .align("center")
        .line("ขอบคุณที่ใช้บริการ")
        .newline()
        .newline()
        .cut();

      const bytes = e.encode();
      await sendToPosPrinter(bytes);

      setIsPosModalOpen(false);
    } catch (err) {
      console.error("confirmPrintPOS error:", err);
      alert("พิมพ์ POS ไม่สำเร็จ");
    }
  };

  // ===== POS Preview UI helpers =====
  const RowSummary = ({ label, value }) => (
    <div style={{ display: "flex" }}>
      <span>{label}</span>
      <span style={{ marginLeft: "auto" }}>{Number(value || 0).toFixed(2)}</span>
    </div>
  );

  const RowSummaryBold = ({ label, value }) => (
    <div style={{ display: "flex", fontWeight: "bold" }}>
      <span>{label}</span>
      <span style={{ marginLeft: "auto" }}>{Number(value || 0).toFixed(2)}</span>
    </div>
  );

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Card>
          <CardHeader
            className="bg-white border-0"
            style={{ padding: "1.25rem 1.5rem" }}
          >
            <Row className="align-items-center">
              <Col xs="12" lg="6">
                <h6 className="mb-0">รายการบิล</h6>
              </Col>
            </Row>
          </CardHeader>

          <CardBody
            className="border-0"
            style={{ backgroundColor: "#f7f9fb", padding: "1.5rem 1.75rem" }}
          >
            {/* Toolbar: page-size + search */}
            <div className="mb-3">
              <Row className="align-items-center g-0">
                <Col
                  xs="12"
                  md="6"
                  className="d-flex align-items-center flex-wrap"
                  style={{ gap: 8 }}
                >
                  <Input
                    type="select"
                    value={pageSize}
                    onChange={(e) => setPageSize(TABLE_KEY, Number(e.target.value))}
                    style={{ width: 96 }}
                  >
                    {PAGE_SIZE_OPTIONS.map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </Input>
                  <span className="text-muted">แถว/หน้า</span>
                </Col>

                <Col
                  xs="12"
                  md="6"
                  className="mt-2 mt-md-0 d-flex justify-content-md-end"
                >
                  <Input
                    type="text"
                    placeholder="ค้นหา เลขที่บิล/ลูกค้า/บริการ"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    className="table-modern-search w-100 w-md-auto"
                    style={{ maxWidth: 320, minWidth: 320 }}
                  />
                </Col>
              </Row>
            </div>

            {/* ✅ TABLE: เล็ก=เดิม, กลาง/ใหญ่=แบบ Product */}
            {isSmall ? (
              <div className="table-responsive">
                <Table
                  responsive
                  hover
                  borderless
                  className="table table-modern mb-0 bill-table"
                >
                  <thead className="thead-colored">
                    <tr>
                      <th>เลขที่บิล</th>
                      <th>ลูกค้า</th>
                      <th>บริการ</th>
                      <th>วันที่รับ</th>
                      <th>วันที่ส่ง</th>
                      <th>สถานะ</th>
                      <th className="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading && (
                      <tr>
                        <td colSpan={7} className="text-center py-4">
                          กำลังโหลดข้อมูล...
                        </td>
                      </tr>
                    )}

                    {!isLoading && filteredTotal === 0 && (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">
                          ไม่พบข้อมูลบิล
                        </td>
                      </tr>
                    )}

                    {!isLoading &&
                      displayRows.map((r) => (
                        <tr key={r.bNumber}>
                          <td data-th="เลขที่บิล">{r.bNumber}</td>
                          <td data-th="ลูกค้า">
                            ({r.cmCode}) {r.cmName}
                          </td>
                          <td data-th="บริการ">{r.svName}</td>
                          <td data-th="วันที่รับ">{thaiDate(r.bReceive)}</td>
                          <td data-th="วันที่ส่ง">{thaiDate(r.bDuedate)}</td>
                          <td data-th="สถานะ">
                            <span className="text-warning font-weight-bold text-center">
                              -
                            </span>
                          </td>
                          <td className="text-center" data-th="จัดการ">
                            <Button
                              color="warning"
                              size="sm"
                              className="mr-2"
                              onClick={() => goEdit(r)}
                            >
                              แก้ไข
                            </Button>
                            <Button
                              color="secondary"
                              size="sm"
                              className="mr-2"
                              onClick={() => handlePrint(r)}
                            >
                              พิมพ์ PDF
                            </Button>
                            <Button
                              color="secondary"
                              size="sm"
                              className="mr-2"
                              onClick={() => handlePrintPOS(r, { paper: "58" })}
                            >
                              พิมพ์ POS
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="zi-table-wrap">
                <Table responsive hover className="zi-table mb-0">
                  <thead>
                    <tr>
                      <th className="text-start" style={{ width: 140 }}>
                        เลขที่บิล
                      </th>
                      <th className="text-start" style={{ width: 260 }}>
                        ลูกค้า
                      </th>
                      <th className="text-start">บริการ</th>
                      <th className="text-start" style={{ width: 140 }}>
                        วันที่รับ
                      </th>
                      <th className="text-start" style={{ width: 140 }}>
                        วันที่ส่ง
                      </th>
                      <th className="text-start" style={{ width: 120 }}>
                        สถานะ
                      </th>
                      <th className="text-end" style={{ width: 240 }}>
                        การจัดการ
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan={7} className="text-center text-muted py-4">
                          กำลังโหลด...
                        </td>
                      </tr>
                    ) : displayRows.length === 0 ? (
                      <tr>
                        <td colSpan={7} className="text-center text-muted py-4">
                          ไม่พบข้อมูลบิล
                        </td>
                      </tr>
                    ) : (
                      displayRows.map((r) => (
                        <tr key={r.bNumber}>
                          <td className="text-start">{r.bNumber}</td>
                          <td className="text-start fw-600">
                            ({r.cmCode}) {r.cmName}
                          </td>
                          <td className="text-start">{r.svName}</td>
                          <td className="text-start">{thaiDate(r.bReceive)}</td>
                          <td className="text-start">{thaiDate(r.bDuedate)}</td>
                          <td className="text-start">
                            <span className="text-warning font-weight-bold">
                              -
                            </span>
                          </td>
                          <td className="text-end">
                            <div className="d-inline-flex gap-2">
                              <Button
                                size="sm"
                                color="warning"
                                onClick={() => goEdit(r)}
                              >
                                แก้ไข
                              </Button>
                              <Button
                                size="sm"
                                color="secondary"
                                onClick={() => handlePrint(r)}
                              >
                                พิมพ์ PDF
                              </Button>
                              <Button
                                size="sm"
                                color="secondary"
                                onClick={() => handlePrintPOS(r, { paper: "58" })}
                              >
                                พิมพ์ POS
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            )}

            {/* Summary */}
            <div className="d-flex justify-content-end justify-content-sm-end justify-content-center mt-2">
              <div className="text-muted small">
                แสดง {(page - 1) * pageSize + (displayRows.length ? 1 : 0)}–
                {Math.min(page * pageSize, filteredTotal)} จากทั้งหมด{" "}
                {filteredTotal} รายการ
              </div>
            </div>

            {/* ✅ CSS แบบ Product (จอใหญ่/กลาง) */}
            <style>{`
              .zi-table-wrap{
                background:#fff;
                border-radius:10px;
                border:1px solid rgba(0,0,0,.06);
                overflow:hidden;
              }
              .zi-table{ margin:0; }
              .zi-table thead th{
                background:#f7fafc;
                color:#0f172a;
                font-weight:700;
                font-size:14px;
                border-bottom:1px solid rgba(0,0,0,.06);
                padding:14px 16px;
                white-space:nowrap;
              }
              .zi-table tbody td{
                padding:14px 16px;
                border-top:1px solid rgba(0,0,0,.06);
                vertical-align:middle;
                font-size:14px;
                color:#0f172a;
              }
              .zi-table tbody tr:hover{ background:#f9fbff; }
              .fw-600{ font-weight:600; }
            `}</style>
          </CardBody>

          {/* Pagination */}
          {filteredTotal > 0 && (
            <CardFooter
              className="py-4"
              style={{ position: "relative", zIndex: 10 }}
            >
              <div className="paging-wrap">
                <button
                  className="paging-btn icon"
                  onClick={() => setPage(TABLE_KEY, Math.max(1, page - 1))}
                  disabled={page === 1}
                  aria-label="Previous page"
                >
                  ‹
                </button>

                {pages.map((p) => (
                  <button
                    key={p}
                    className={`paging-btn ${page === p ? "active" : ""}`}
                    onClick={() => setPage(TABLE_KEY, p)}
                  >
                    {p}
                  </button>
                ))}

                <button
                  className="paging-btn icon"
                  onClick={() =>
                    setPage(TABLE_KEY, Math.min(filteredPageCount, page + 1))
                  }
                  disabled={page === filteredPageCount}
                  aria-label="Next page"
                >
                  ›
                </button>
              </div>
            </CardFooter>
          )}
        </Card>
      </Container>

      {/* Modal: เพิ่มลูกค้า */}
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={toggleModal}>เพิ่มลูกค้า</ModalHeader>
        <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
          <Form>
            <div className="pl-lg-4">
              <Row>
                <div className="col-12">
                  <FormGroup>
                    {customerTypeOptions.map((o) => {
                      const active = form.customerType === o.value;
                      return (
                        <Button
                          key={o.value}
                          size="sm"
                          outline={!active}
                          color={active ? "primary" : "secondary"}
                          className="mr-2 mb-2 rounded-pill"
                          onClick={() =>
                            setForm((s) => ({ ...s, customerType: o.value }))
                          }
                          aria-pressed={active}
                        >
                          {o.label}
                        </Button>
                      );
                    })}
                    <Input
                      type="hidden"
                      name="customerType"
                      value={form.customerType}
                      onChange={onChange}
                    />
                  </FormGroup>
                </div>
              </Row>

              <Row>
                <div className="col-12 col-lg-6">
                  <FormGroup>
                    <label className="form-control-label required">ชื่อลูกค้า</label>
                    <Input className="form-control-alternative" type="text" />
                  </FormGroup>
                </div>
                <div className="col-12 col-lg-6">
                  <FormGroup>
                    <label className="form-control-label required">เบอร์โทร</label>
                    <Input className="form-control-alternative" type="text" />
                  </FormGroup>
                </div>
              </Row>
            </div>

            <div className="text-right mt-4">
              <Button
                color="primary"
                onClick={() => {
                  console.log("บันทึกข้อมูลลูกค้า:", form);
                  toggleModal();
                }}
                style={{ minWidth: 120 }}
              >
                บันทึก
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      {/* Modal: ตารางแพ็กเกจของลูกค้า */}
      <Modal
        isOpen={isPkgModalOpen}
        toggle={() => setIsPkgModalOpen((v) => !v)}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={() => setIsPkgModalOpen((v) => !v)}>
          แพ็กเกจของลูกค้า
        </ModalHeader>
        <ModalBody>
          {!selectedCustomer ? (
            <div className="text-center text-muted">ไม่พบข้อมูลลูกค้า</div>
          ) : (
            <>
              <div className="mb-3" style={{ fontWeight: 600 }}>
                ({selectedCustomer.code}) {selectedCustomer.name}
              </div>
              <Table
                responsive
                hover
                borderless
                className="table table-modern mb-0 bill-table"
              >
                <thead>
                  <tr style={{ color: "#6b7280", fontWeight: 600 }}>
                    <th>รหัสบิล</th>
                    <th>แพ็คเกจ</th>
                    <th>วันหมดอายุ</th>
                    <th>เหลือ(ชิ้น)</th>
                    <th>ทำรายการ</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCustomer.packages.map((p) => (
                    <tr key={p.billNo} style={{ verticalAlign: "middle" }}>
                      <td style={{ fontWeight: 600 }}>{p.billNo}</td>
                      <td>{p.packageName}</td>
                      <td>{thaiDate(p.expireAt)}</td>
                      <td>{p.remain}</td>
                      <td className="actions">
                        <Button
                          style={{
                            background: "#10a5ff",
                            border: "none",
                            color: "#fff",
                            borderRadius: 10,
                            padding: "8px 14px",
                            fontWeight: 700,
                          }}
                          onClick={handlePackageCustomer}
                        >
                          ทำรายการ
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      {/* Modal: POS Preview */}
      <Modal
        isOpen={isPosModalOpen}
        toggle={() => setIsPosModalOpen(false)}
        size="sm"
        centered
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-header">
          <h5 className="modal-title">ตัวอย่างบิล POS</h5>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={() => setIsPosModalOpen(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>

        <div className="modal-body">
          {!posPreview ? (
            <div className="text-center text-muted">ไม่มีข้อมูลบิล</div>
          ) : (
            <div
              style={{
                width: "58mm",
                margin: "0 auto",
                fontFamily: "monospace",
                fontSize: 12,
                background: "#fff",
                padding: "8px",
                border: "1px solid #e5e7eb",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: 8 }}>
                {posPreview.org?.nameTH && (
                  <div style={{ fontWeight: "bold" }}>{posPreview.org.nameTH}</div>
                )}
                {posPreview.org?.taxId && (
                  <div>เลขผู้เสียภาษี: {posPreview.org.taxId}</div>
                )}
              </div>

              <div style={{ marginBottom: 4 }}>
                เลขที่บิล: {posPreview.billNo}
                <br />
                วันที่: {posPreview.billDate}
              </div>

              <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

              <div style={{ marginBottom: 4 }}>
                ลูกค้า: {posPreview.buyerName}
                <br />
                ที่อยู่: {posPreview.buyerAddress}
              </div>

              <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

              {/* ✅ แยก UI Preview: รายชิ้น vs แพ็คเกจ */}
              {posPreview.service?.isPiece ? (
                <>
                  {posPreview.items.map((it, idx) => (
                    <div key={idx} style={{ marginBottom: 2 }}>
                      <div>{it.pdName}</div>
                      <div style={{ display: "flex" }}>
                        <span>
                          {it.qty} x {Number(it.price || 0).toFixed(2)}
                        </span>
                        <span style={{ marginLeft: "auto" }}>
                          {Number(it.lineTotal || 0).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  ))}

                  <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

                  <RowSummary label="รวม" value={posPreview.total} />
                  <RowSummary label="ภาษี 7%" value={posPreview.vat} />
                  <RowSummaryBold label="ยอดสุทธิ" value={posPreview.grand} />
                </>
              ) : (
                <>
                  <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: 6 }}>
                    รายการแพ็คเกจ
                  </div>
                  <div style={{ marginBottom: 6 }}>
                    {posPreview.service?.svName ||
                      posPreview.service?.svType ||
                      "แพ็คเกจ"}
                  </div>

                  <div style={{ borderTop: "1px dashed #999", margin: "4px 0" }} />

                  <RowSummary
                    label="ราคาแพ็คเกจ"
                    value={posPreview.service?.svPrice || 0}
                  />
                  <RowSummary label="ภาษี" value={0} />
                  <RowSummaryBold
                    label="ยอดสุทธิ"
                    value={posPreview.service?.svPrice || 0}
                  />
                </>
              )}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <Button
            color="secondary"
            size="sm"
            onClick={() => setIsPosModalOpen(false)}
          >
            ยกเลิก
          </Button>
          <Button color="primary" size="sm" onClick={confirmPrintPOS}>
            ยืนยันพิมพ์ POS
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default OrderOrgs;
